import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../services/auth.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.css']
})
export class PasswordChangeComponent implements OnInit {

  passwordChangeForm: FormGroup;
  notFocused = false;
  submitted: boolean;
  show = false;
  title = 'IBD Tool';

  constructor(private authService: AuthService,
              public dialog: MatDialog) { }

  ngOnInit(): void {
    this.passwordChangeForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      SSN: new FormControl('', [Validators.required]),
    });
  }

  onSubmit(form) {
    this.submitted = true;
    this.show = true;
    console.log(form);
    this.authService.changePasswordRequest(form);
  }

}
